module.exports = "/* /Users/guoyingxu/qst/ckeditor-build/src/plugins/ckeditor5-textintent/src/index.css */\n.ck-textindent{\n  text-indent: 2em\n}"